import { Sluggable } from '@client/core/data/concerns/sluggable';
import { $t } from '@client/i18n/t';

/**
 * This is a client side configuration of the API model with the same name.
 * See: app/Models/ConstructionMaterial/ConstructionMaterialCategory.php
 */
export class ConstructionMaterialCategory extends Sluggable<ConstructionMaterialCategory>() {
  static readonly appliances = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.appliances'),
    slug: 'appliances',
  });

  static readonly buildingSupplies = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.buildingSupplies'),
    slug: 'building-supplies',
  });

  static readonly doors = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.doors'),
    slug: 'doors',
  });

  static readonly electrical = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.electrical'),
    slug: 'electrical',
  });

  static readonly flooring = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.flooring'),
    slug: 'flooring',
  });

  static readonly furnishings = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.furnishings'),
    slug: 'furnishings',
  });

  static readonly hardware = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.hardware'),
    slug: 'hardware',
  });

  static readonly hvac = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.hvac'),
    slug: 'hvac',
  });

  static readonly landscaping = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.landscaping'),
    slug: 'landscaping',
  });

  static readonly lightingAndFans = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.lightingAndFans'),
    slug: 'lighting-fans',
  });

  static readonly paint = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.paint'),
    slug: 'paint',
  });

  static readonly plumbing = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.plumbing'),
    slug: 'plumbing',
  });

  static readonly smartHome = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.smartHome'),
    slug: 'smart-home',
  });

  static readonly storage = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.storage'),
    slug: 'storage',
  });

  static readonly tiling = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.tiling'),
    slug: 'tiling',
  });

  static readonly woodwork = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.woodwork'),
    slug: 'woodwork',
  });

  static readonly windows = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.windows'),
    slug: 'windows',
  });

  static readonly misc = new ConstructionMaterialCategory({
    name: $t('constructionMaterial.categories.misc'),
    slug: 'misc',
  });

  static readonly values: ConstructionMaterialCategory[] = [
    this.appliances,
    this.buildingSupplies,
    this.doors,
    this.electrical,
    this.flooring,
    this.furnishings,
    this.hardware,
    this.hvac,
    this.landscaping,
    this.lightingAndFans,
    this.paint,
    this.plumbing,
    this.smartHome,
    this.storage,
    this.tiling,
    this.woodwork,
    this.windows,
    this.misc,
  ];
}
